// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../../share/util/individualDiagnose';
import config from '../../../../../share/config';
import session from '../../../../../share/session';
import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import error from '../../../../../common/nodejs/errors';

/**
 * 個別項目 設定値一覧の設定値定義
 * 設定値リスト表示文言の翻訳キーにも使用
 */
const VALUE_LIST = [
  '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '0A', '0B',
  '0C', '0D', '0E', '0F', '10', '11', '12', '13', '14', '15', '16', '17',
  '18', '19', '1A', '1B', '1C', '1D', '1E', '1F', '20', '21', '22', '23',
  'FF'
];

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  ITEM_LIST: 'itemList',
  SETTING_VALUE_LIST: 'settingValueList',
  CHANGE_SETTING: 'changeSetting',
  RETRY_CONFIRMATION: 'retryConfirmation',
  SUCCESS: 'success',
  STOP: 'stop',
  NOT_SUPPORT_DID: 'notSupportDid',
  WRITE_FAILED: 'writeFailed',
  FAILED: 'failed',
};

export default {
  name: 'requirementSpMET',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      systemId: '',
      itemList: [],
      selectItems: {},
      selectSourceId: '',
      settingValueList: [],
      selectSettingValue: '',
      modal_requirement_MET: false
    };
  },

  props: {
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.NOT_SUPPORT_DID:
        case PHASE.WRITE_FAILED:
        case PHASE.FAILED:
          return 'danger';
        case PHASE.CHANGE_SETTING:
        case PHASE.SUCCESS:
          return 'success';
        default:
          return 'secondary';
      }
    },

    // 現在のモードラベルの表示確認
    showCurrentModeLabel() {
      const showCurrentModeLabelMap = {
        itemList: true,
        settingValueList: true,
        changeSetting: true,
        retryConfirmation: true,
        stop: true
      };
      let result = showCurrentModeLabelMap[this.phase];
      if (!result) {
        // 合致しない場合は false とする。
        result = false;
      }
      return result;
    },
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.modal_requirement_MET = true;
      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      // リソース(特殊機能_DID)のi18nキー取得
      this.i18nSpwsDidKey = `spwsDid${this.systemId}`;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_MET = false;
    },

    /** 機能終了 */
    async exit() {
      // terminate用APIを実行後に画面を閉じる
      await this.terminate();
      // 画面を閉じる
      this.closeWizard();
    },

    /** モード変更（データ読み出し） */
    async readMode() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        // モード変更（データ読み出し）(要求)（バックエンドAPI_POST） Getのポーリング処理も行う
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read_mode',
            is_special: true,
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response){
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // read_dataは配列0固定
              if (response.data.user_data.read_data[0].data_record === "FF") {
                // 0xFF(書込みモード)の場合、待機画面（項目表示）へ遷移
                await this.supportDidRead();
              } else {
                // 上記以外の場合、モード変更（NonDefaultSession遷移）を実行
                await this.standby();
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** モード変更（NonDefaultSession遷移） */
    async standby() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        // モード変更（NonDefaultSession遷移）(要求)（バックエンドAPI_POST） Getのポーリング処理も行う
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'standby',
            is_special: true,
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response){
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了時、モード変更（データ書き込み）を実行する
              await this.writeMode();
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** モード変更（データ書き込み） */
    async writeMode() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        // モード変更（データ書き込み）(要求)（バックエンドAPI_POST） Getのポーリング処理も行う
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write_mode',
            is_special: true,
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response){
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了時、待機画面（項目表示）へ遷移
              await this.supportDidRead();
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 本ダイアログを閉じるときの処理(terminate APIの実行) */
    async terminate() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        // terminate (要求)（バックエンドAPI_POST） Getのポーリング処理も行う
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'terminate',
            is_special: true,
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * サポートDIDの読出し
     */
    async supportDidRead() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        // サポートDID読出し (要求)（バックエンドAPI_POST） Getのポーリング処理も行う
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'support_read',
            is_special: true,
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 成功
          if (response.data.status === config.STATUS_WSP_COMPLETED) {
            this.setItemList(response.data.user_data.supported_did_list);
          } else {
            // サポートデータなしエラー
            if (response.data.async_code === error.WSP_NOT_SUPPORTED_DID_ERROR) {
              this.phase = PHASE.NOT_SUPPORT_DID;
            } else {
            // 上記以外のエラー
              this.showUnexpectedError();
            }
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * データ読出し
     */
    async read() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        // データ読出し(要求)（バックエンドAPI_POST） Getのポーリング処理も行う
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read',
            did: this.selectItems.did,
            is_special: true,
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response){
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              this.setSettingValueList(response.data.user_data.read_data);
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * データ書込み
     */
    async write() {
      try {
        let writeData = {};
        // Phaseによって設定するwriteDataを変更する
        switch (this.phase) {
          case PHASE.SETTING_VALUE_LIST: {
            const targetSelectObj = this.settingValueList.find(obj => obj.value === this.selectSettingValue);
            writeData = {
              id: this.selectItems.did,
              value: this.selectSettingValue,
              byte_data: targetSelectObj ? targetSelectObj.byteData : undefined,
              start_byte_position: targetSelectObj ? targetSelectObj.startBytePosition : undefined,
              start_bit_position: targetSelectObj ? targetSelectObj.startBitPosition : undefined,
              bit_size: targetSelectObj ? targetSelectObj.bit_size : undefined
            };
            break;
          }
          case PHASE.RETRY_CONFIRMATION:
          default:
            writeData = {
              id: '10C2',
              value: '00'
            };
            break;
        }
        this.isLoading = true;
        const token = session.getToken();
        // データ書込み(要求)（バックエンドAPI_POST） Getのポーリング処理も行う
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write',
            write_data: writeData,
            is_special: true,
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response){
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              if (this.phase === PHASE.SETTING_VALUE_LIST) {
                this.phase = PHASE.CHANGE_SETTING;
              } else {
                this.phase = PHASE.SUCCESS;
              }
              break;
            default:
              if (this.phase === PHASE.SETTING_VALUE_LIST){
                this.showUnexpectedError();
              } else {
                this.phase = PHASE.WRITE_FAILED;
              }
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 待機画面 項目セット
     * @param {Array} support_list サポートDID読み出し結果(DID_byte_bit)
     */
    setItemList(support_list){
      this.itemList = support_list.filter(item =>
        // 文言が存在しない場合はスキップ
        this.$te(`${this.i18nSpwsDidKey}.${item}`)
      ).map(filterItem => {
        return {
          text: this.$t(`${this.i18nSpwsDidKey}.${filterItem}`),
          value: {
            // 先頭からアンダーバーまでの範囲を切り出し、DIDとする
            did: filterItem.substring(0, filterItem.indexOf('_')),
            source_id: filterItem
          }
        };
      });

      // 1件も項目に変換できなかった場合は非サポートエラーに遷移する
      if (this.itemList.length < 1) {
        this.phase = PHASE.NOT_SUPPORT_DID;
        return;
      }

      this.itemList.sort((a, b) =>  a.value.did > b.value.did ? 1 : -1 );
      this.phase = PHASE.ITEM_LIST;
    },

    /**
     * 実行画面 項目セット
     * @param {Array} did_results DID読み出し結果
     */
    setSettingValueList(did_results){
      const targetData = did_results.find(data => data.id === this.selectItems.source_id);
      // 該当の項目に対応するDIDが取得できなかった場合、通信エラーに遷移する
      if (!targetData) {
        this.phase = PHASE.FAILED;
        return;
      }
      this.settingValueList = VALUE_LIST.filter(setting =>
        // 文言が存在しない場合はスキップ
        this.$te(`${this.i18nSpwsDidKey}.${targetData.id}_${setting}`)
      ).map(filterSetting => {
        return {
          text: this.$t(`${this.i18nSpwsDidKey}.${targetData.id}_${filterSetting}`),
          value: filterSetting,
          byteData: targetData.byte_data,
          startBytePosition: targetData.start_byte_position,
          startBitPosition: targetData.start_bit_position,
          bit_size: targetData.bit_size
        };
      });

      this.settingValueList.sort((a, b) =>  a.value > b.value ? 1 : -1 );
      // 現在値を選択済にする。converted_data_recordは1文字の場合もあるので、0でpaddingする
      this.selectSettingValue = targetData.converted_data_record ? targetData.converted_data_record.padStart(2, '0').toUpperCase() : '';

      this.phase = PHASE.SETTING_VALUE_LIST;
    },

    /** 待機画面 次へボタン押下イベント */
    async moveSettingValueEvent() {
      await this.read();
    },

    /** 実行画面 キャンセルボタン押下 or 再実行確認表示画面 OKボタン押下イベント or 中断表示画面 NOボタン押下イベント */
    async returnDisplayEvent() {
      this.selectItems = undefined;
      this.selectSettingValue = undefined;
      this.phase = PHASE.ITEM_LIST;
    },
    /** 設定変更表示画面 OKボタン押下イベント */
    async moveRetryConfirmationEvent() {
      this.phase = PHASE.RETRY_CONFIRMATION;
    },
    /** 実行画面 OKボタン押下, 再実行確認表示画面 キャンセルボタン押下イベント */
    async writeEvent() {
      await this.write();
    },

    /** 待機画面のキャンセルボタン押下 */
    moveStopEvent() {
      // 中断表示画面に遷移
      this.phase = PHASE.STOP;
    },

    /** その他エラー発生時の表示 */
    async showUnexpectedError() {
      // 異常終了：エラー表示
      this.phase = PHASE.FAILED;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },
  },

  async mounted() {
    this.init();
    // モード変更（データ読み出し）の実行
    await this.readMode();
  },
};